import useStyles from './styles';

const WarningComponent = ({ componentName }: { componentName: string }) => {
  const styles = useStyles();

  return (
    <div className={styles.root} data-testid="warning-test">
      <div>Warning</div>
      <div>Can not find the &quot;{componentName}&quot; component</div>
    </div>
  );
};

export default WarningComponent;
